<template>
    <div class="page-wrapper">
        <h3 class="tit">总大屏</h3>
        <div class="top-btns">
            <el-button class="r-btn" type="primary" icon="el-icon-edit" size="medium" @click="editHandle" :disabled="!uneditable">编辑表单</el-button>
            <br>
            <el-button class="r-btn" type="success" icon="el-icon-link" size="medium" @click="linkToDataV">查看大屏</el-button>
            <br>
            <el-button class="r-btn" type="warning" icon="el-icon-circle-check" size="medium" @click="takeEffectAtOnce">立即生效</el-button>
            <br>
            <el-button class="r-btn" type="info" icon="el-icon-top" size="medium" @click="toPageTop">回到顶部</el-button>
        </div>
        <div class="datav-form-wrapper">
            <el-form class="c-form" :model="editForm" ref="editForm" label-position="top">
                <el-form-item class="c-form-item" label="线上订单总金额">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-head/001.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-head/001.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        线上订单总金额 = 衣加加生产加工订单总金额（包括得体导入到衣加加的数据）+ 订货会成交总金额 +云仓成交总额+ 2708（固定基数）+ 每天随机增加1-3万金额（即1、2、3 单位为万）
                    </p>
                    <el-form-item class="c-form-item-inner"
                        label="固定基数（整数）"
                        prop="totalOrderAmount.radix"
                        :rules="[
                            { required: true, message: '请输入整数', trigger: 'blur' }
                        ]"
                    >
                        <el-input
                            class="w"
                            v-model="editForm.totalOrderAmount.radix"
                            @blur="editForm.totalOrderAmount.radix = switchToInt(editForm.totalOrderAmount.radix)"
                            placeholder="请输入固定基数"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                    <el-form-item class="c-form-item-inner" label="随机金额范围（正整数）" required>
                        <el-col :span="6">
                            <el-form-item
                                prop="totalOrderAmount.dayMin"
                                :rules="[
                                    { required: true, message: '请输入整数最小金额', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.totalOrderAmount.dayMin = switchToInt(editForm.totalOrderAmount.dayMin, 'unsigned');switchObjMaxAndMin(editForm.totalOrderAmount, 'dayMin', 'dayMax')"
                                    v-model="editForm.totalOrderAmount.dayMin"
                                    placeholder="请输入最小金额"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col class="gap-line" :span="1">-</el-col>
                        <el-col :span="6">
                            <el-form-item
                                prop="totalOrderAmount.dayMax"
                                :rules="[
                                    { required: true, message: '请输入整数最大金额', trigger: 'blur' }
                                ]"
                            >
                                <el-input
                                    @blur="editForm.totalOrderAmount.dayMax = switchToInt(editForm.totalOrderAmount.dayMax, 'unsigned');switchObjMaxAndMin(editForm.totalOrderAmount, 'dayMin', 'dayMax')"
                                    v-model="editForm.totalOrderAmount.dayMax"
                                    placeholder="请输入最大金额"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="订单总数">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-head/002.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-head/002.png">
                        </div>
                    </el-popover>
                    <p class="info">
                       线上订单总数 = 衣加加生产加工订单总数（包括得体导入到衣加加的数据）+ 订货会成交订单 +云仓成交订单（播款网平台交易数量“具体与刘超沟通”）+ 培训人员数量（可后台录入）
                    </p>
                    <el-form-item class="c-form-item-inner" label="培训人员数量（整数）"
                        prop="totalOrderNumber.radix"
                        :rules="[
                            { required: true, message: '请输入整数', trigger: 'blur' },
                        ]"
                    >
                        <el-input
                            @blur="editForm.totalOrderNumber.radix = switchToInt(editForm.totalOrderNumber.radix)"
                            class="w"
                            v-model="editForm.totalOrderNumber.radix"
                            placeholder="请输入培训人员数量"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="本月注册">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-head/003.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-head/003.png">
                        </div>
                    </el-popover>
                    <p class="info">
                       本周注册改成本月注册=综合体官网注册数量+所有模块的注册数量（目前主要是衣加加和播款网平台）
                    </p>
                    <el-form-item class="c-form-item-inner" label="固定基数（整数）"
                        prop="monthRegistrations.radix"
                        :rules="[
                            { required: true, message: '请输入整数', trigger: 'blur' },
                        ]"
                    >
                        <el-input
                            @blur="editForm.monthRegistrations.radix = switchToInt(editForm.monthRegistrations.radix)"
                            class="w"
                            v-model="editForm.monthRegistrations.radix"
                            placeholder="请输入固定基数"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="平均月活跃用户">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-head/004.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-head/004.png">
                        </div>
                    </el-popover>
                    <p class="info">
                       改成月活跃用户=综合体官网查阅数量+其他综合体系统被打开应用的次数+播款网小程序活跃度（打开使用次数）
                    </p>
                    <el-form-item class="c-form-item-inner" label="固定基数（整数）"
                        prop="monthActiveUsers.radix"
                        :rules="[
                            { required: true, message: '请输入整数', trigger: 'blur' },
                        ]"
                    >
                        <el-input
                            @blur="editForm.monthActiveUsers.radix = switchToInt(editForm.monthActiveUsers.radix)"
                            class="w"
                            v-model="editForm.monthActiveUsers.radix"
                            placeholder="请输入固定基数"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="注册技能人员数">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-head/005.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-head/005.png">
                        </div>
                    </el-popover>
                    <p class="info">
                       注册技能人员数=技工大赛数量+2000+培训企业学员数量（和培训人员数量同一个数字）
                    </p>
                    <el-form-item class="c-form-item-inner" label="固定基数（整数）"
                        prop="skilledPersons.radix"
                        :rules="[
                            { required: true, message: '请输入整数', trigger: 'blur' },
                        ]"
                    >
                        <el-input
                            @blur="editForm.skilledPersons.radix = switchToInt(editForm.skilledPersons.radix)"
                            class="w"
                            v-model="editForm.skilledPersons.radix"
                            placeholder="请输入固定基数"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="带动就业人数">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-head/006.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-head/006.png">
                        </div>
                    </el-popover>
                    <p class="info">
                       带动就业人数=100000+培训人员数量+技工大赛报名人数+注册企业总数量*10
                    </p>
                    <el-form-item class="c-form-item-inner" label="固定基数（整数）"
                        prop="createJobs.radix"
                        :rules="[
                            { required: true, message: '请输入整数', trigger: 'blur' },
                        ]"
                    >
                        <el-input
                            @blur="editForm.createJobs.radix = switchToInt(editForm.createJobs.radix)"
                            class="w"
                            v-model="editForm.createJobs.radix"
                            placeholder="请输入固定基数"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                </el-form-item>

                <el-form-item class="c-form-item" label="订单种类统计">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-head/007.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-head/007.png">
                        </div>
                    </el-popover>
                    <p class="info">
                        面料改成面辅料=面料注册企业家数*10+衣加加生产订单数量的件数<br>
                        设计=设计企业注册数量*10+订货会订单数量<br>
                        版房=260+方老师接单数量（云衣公社小程序，具体和黄鲁勇沟通）<br>
                        加工=生产工厂注册数量*20+衣加加生产订单数量<br>
                        销售=云仓订单+得体销售订单+播款网系统销售订单量<br>
                    </p>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="面辅料基数（整数）"
                                prop="orderTypeCount.fabric"
                                :rules="[
                                    { required: true, message: '请输入整数', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.orderTypeCount.fabric = switchToInt(editForm.orderTypeCount.fabric)"
                                    v-model="editForm.orderTypeCount.fabric"
                                    placeholder="请输入面辅料基数"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="设计基数（整数）"
                                prop="orderTypeCount.design"
                                :rules="[
                                    { required: true, message: '请输入整数', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.orderTypeCount.design = switchToInt(editForm.orderTypeCount.design)"
                                    v-model="editForm.orderTypeCount.design"
                                    placeholder="请输入设计基数"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="版房基数（整数）"
                                prop="orderTypeCount.sampleRoom"
                                :rules="[
                                    { required: true, message: '请输入整数', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.orderTypeCount.sampleRoom = switchToInt(editForm.orderTypeCount.sampleRoom)"
                                    v-model="editForm.orderTypeCount.sampleRoom"
                                    placeholder="请输入版房基数"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="加工基数（整数）"
                                prop="orderTypeCount.processing"
                                :rules="[
                                    { required: true, message: '请输入整数', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.orderTypeCount.processing = switchToInt(editForm.orderTypeCount.processing)"
                                    v-model="editForm.orderTypeCount.processing"
                                    placeholder="请输入加工基数"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="销售基数（整数）"
                                prop="orderTypeCount.sales"
                                :rules="[
                                    { required: true, message: '请输入整数', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.orderTypeCount.sales = switchToInt(editForm.orderTypeCount.sales)"
                                    v-model="editForm.orderTypeCount.sales"
                                    placeholder="请输入销售基数"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form-item>

                <el-form-item class="c-form-item" label="各产业园区产值及数据">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-head/008.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-head/008.png">
                        </div>
                    </el-popover>
                    <p class="info">
                       按1-8的排序，自动按年度生成数据，以下表达一年总金额，按阳历月份自动增长（每月）， 产值基数为正整数
                    </p>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.outputValueCount" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="9">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'outputValueCount.' + index + '.name'"
                                    :rules="[
                                        { required: true, message: '请输入园区名', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.name" :disabled="uneditable">
                                        <template slot="prepend">园区名</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'outputValueCount.' + index + '.radix'"
                                    :rules="[
                                        { required: true, message: '请输入整数', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.radix" :disabled="uneditable"
                                        @blur="item.radix = switchToInt(item.radix, 'unsigned')"
                                    >
                                        <template slot="prepend">产值基数</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.outputValueCount.length === 1}" 
                                    :title="editForm.outputValueCount.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('outputValueCount', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('outputValueCount', index)"
                                ></i>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>
                <el-form-item class="c-form-item" label="用户数量">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-head/009.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-head/009.png">
                        </div>
                    </el-popover>
                    <el-form-item class="c-form-item-inner" label="固定基数（整数）"
                        prop="userNumber.radix"
                        :rules="[
                            { required: true, message: '请输入整数', trigger: 'blur' },
                        ]"
                    >
                        <el-input
                            @blur="editForm.userNumber.radix = switchToInt(editForm.userNumber.radix)"
                            class="w"
                            v-model="editForm.userNumber.radix"
                            placeholder="请输入用户数量的固定基数"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                </el-form-item>
                <el-form-item class="c-form-item" label="公司数量">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-head/009.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-head/009.png">
                        </div>
                    </el-popover>
                    <el-form-item class="c-form-item-inner" label="固定基数（整数）"
                        prop="companyNumber.radix"
                        :rules="[
                            { required: true, message: '请输入整数', trigger: 'blur' },
                        ]"
                    >
                        <el-input
                            @blur="editForm.companyNumber.radix = switchToInt(editForm.companyNumber.radix)"
                            class="w"
                            v-model="editForm.companyNumber.radix"
                            placeholder="请输入公司数量的固定基数"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                </el-form-item>
                <el-form-item class="c-form-item" label="面料采购">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-head/010.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-head/010.png">
                        </div>
                    </el-popover>
                    <p class="info">
                       改为面料采购，面料销售金额可填。全年102029米，全年自动增长<br>
                       公式：(本年第N天 / 365) * 全年米数 + 附加数据
                    </p>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="全年米数（正整数）"
                                prop="fabricPurchasing.radix1"
                                :rules="[
                                    { required: true, message: '请输入整数', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.fabricPurchasing.radix1 = switchToInt(editForm.fabricPurchasing.radix1, 'unsigned')"
                                    v-model="editForm.fabricPurchasing.radix1"
                                    placeholder="请输入全年米数"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="附加数据（整数）"
                                prop="fabricPurchasing.radix2"
                                :rules="[
                                    { required: true, message: '请输入整数', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.fabricPurchasing.radix2 = switchToInt(editForm.fabricPurchasing.radix2)"
                                    v-model="editForm.fabricPurchasing.radix2"
                                    placeholder="请输入附加数据"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item class="c-form-item" label="服装库存">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-head/011.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-head/011.png">
                        </div>
                    </el-popover>
                    <p class="info">
                       库存数量=300000+云仓库存总数据
                    </p>
                    <el-form-item class="c-form-item-inner" label="固定基数（整数）"
                        prop="apparelStock.radix"
                        :rules="[
                            { required: true, message: '请输入整数', trigger: 'blur' },
                        ]"
                    >
                        <el-input
                            @blur="editForm.apparelStock.radix = switchToInt(editForm.apparelStock.radix)"
                            class="w"
                            v-model="editForm.apparelStock.radix"
                            placeholder="请输入服装库存的固定基数"
                            :disabled="uneditable"
                        ></el-input>
                    </el-form-item>
                </el-form-item>
                <el-form-item class="c-form-item" label="引导纳税">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-head/012.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-head/012.png">
                        </div>
                    </el-popover>
                    <p class="info">
                       引导纳税=2547（固定基数）+总成金额*5%<br>
                       公式： 线上订单总金额 * 比例 + 附加数据
                    </p>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="比例（小数，例如0.05）"
                                prop="guideTaxPayment.rate"
                                :rules="[
                                    { required: true, message: '请输入小数', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.guideTaxPayment.rate = switchToFloat(editForm.guideTaxPayment.rate, 'unsigned')"
                                    v-model="editForm.guideTaxPayment.rate"
                                    placeholder="请输入比例"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="附加数据（整数）"
                                prop="guideTaxPayment.radix"
                                :rules="[
                                    { required: true, message: '请输入整数', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.guideTaxPayment.radix = switchToInt(editForm.guideTaxPayment.radix)"
                                    v-model="editForm.guideTaxPayment.radix"
                                    placeholder="请输入附加数据"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item class="c-form-item" label="平台各省订单交易信息">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-head/013.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-head/013.png">
                        </div>
                    </el-popover>
                    <p class="info">
                       浙江省=总成交金额*32% <br>
                        广东省=总成交金额*22% <br>
                        上海=总成交金额*7% <br>
                        四川省=总成交金额*12% <br>
                        山东省=总成交金额*10% <br>
                        安徽省=总成交金额*11% <br>
                        湖北省=总成交金额*6%<br>
                        比例为小数，例如0.32，代表32%； 附加数为整数
                    </p>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.provinceOrder" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'provinceOrder.' + index + '.name'"
                                    :rules="[
                                        { required: true, message: '请输入省份', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.name" :disabled="uneditable">
                                        <template slot="prepend">省份</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'provinceOrder.' + index + '.rate'"
                                    :rules="[
                                        { required: true, message: '请输入小数', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.rate" :disabled="uneditable"
                                        @blur="item.rate = switchToFloat(item.rate, 'unsigned')"
                                    >
                                        <template slot="prepend">比例</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'provinceOrder.' + index + '.radix'"
                                    :rules="[
                                        { required: true, message: '请输入整数', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.radix" :disabled="uneditable"
                                        @blur="item.radix = switchToInt(item.radix)"
                                    >
                                        <template slot="prepend">附加数</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.provinceOrder.length === 1}" 
                                    :title="editForm.provinceOrder.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('provinceOrder', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('provinceOrder', index)"
                                ></i>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>
                <el-form-item class="c-form-item" label="服装库存（按季节）">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-head/014.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-head/014.png">
                        </div>
                    </el-popover>
                    <p class="info">
                       各季的服装库存 = 最小值（正整数）和最大值（正整数）之间的随机数
                    </p>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.seasonApparelStock" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'seasonApparelStock.' + index + '.name'"
                                    :rules="[
                                        { required: true, message: '请输入季节名', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.name" :disabled="uneditable">
                                        <template slot="prepend">季节名</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'seasonApparelStock.' + index + '.min'"
                                    :rules="[
                                        { required: true, message: '请输入整数', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.min" :disabled="uneditable"
                                        @blur="item.min = switchToInt(item.min, 'unsigned');switchMaxAndMin(editForm.seasonApparelStock, index)"
                                    >
                                        <template slot="prepend">最小值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'seasonApparelStock.' + index + '.max'"
                                    :rules="[
                                        { required: true, message: '请输入整数', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.max" :disabled="uneditable"
                                        @blur="item.max = switchToInt(item.max, 'unsigned');switchMaxAndMin(editForm.seasonApparelStock, index)"
                                    >
                                        <template slot="prepend">最大值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.seasonApparelStock.length === 1}" 
                                    :title="editForm.seasonApparelStock.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('seasonApparelStock', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('seasonApparelStock', index)"
                                ></i>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>
                <el-form-item class="c-form-item" label="面辅料库存">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-head/015.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-head/015.png">
                        </div>
                    </el-popover>
                    <p class="info">
                       各类面辅料库存 = 最小值和最大值之间的随机数
                    </p>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.fabricStock" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'fabricStock.' + index + '.name'"
                                    :rules="[
                                        { required: true, message: '请输入面辅料', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.name" :disabled="uneditable">
                                        <template slot="prepend">面辅料</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'fabricStock.' + index + '.min'"
                                    :rules="[
                                        { required: true, message: '请输入最小值', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.min" :disabled="uneditable"
                                        @blur="item.min = switchToFloat(item.min, 'unsigned');switchMaxAndMin(editForm.fabricStock, index)"
                                    >
                                        <template slot="prepend">最小值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'fabricStock.' + index + '.max'"
                                    :rules="[
                                        { required: true, message: '请输入最大值', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.max" :disabled="uneditable"
                                        @blur="item.max = switchToFloat(item.max, 'unsigned');switchMaxAndMin(editForm.fabricStock, index)"
                                    >
                                        <template slot="prepend">最大值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.fabricStock.length === 1}" 
                                    :title="editForm.fabricStock.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('fabricStock', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('fabricStock', index)"
                                ></i>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>
                <el-form-item class="c-form-item" label="综合体线下空间统计数据">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-head/016.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-head/016.png">
                        </div>
                    </el-popover>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="品牌孵化空间（正整数）"
                                prop="OfflineSpaceStat.brand"
                                :rules="[
                                    { required: true, message: '请输入整数', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.OfflineSpaceStat.brand = switchToInt(editForm.OfflineSpaceStat.brand, 'unsigned')"
                                    v-model="editForm.OfflineSpaceStat.brand"
                                    placeholder="请输入"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="面料空间（正整数）"
                                prop="OfflineSpaceStat.fabric"
                                :rules="[
                                    { required: true, message: '请输入整数', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.OfflineSpaceStat.fabric = switchToInt(editForm.OfflineSpaceStat.fabric, 'unsigned')"
                                    v-model="editForm.OfflineSpaceStat.fabric"
                                    placeholder="请输入"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="销售空间（正整数）"
                                prop="OfflineSpaceStat.eBusiness"
                                :rules="[
                                    { required: true, message: '请输入整数', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.OfflineSpaceStat.eBusiness = switchToInt(editForm.OfflineSpaceStat.eBusiness, 'unsigned')"
                                    v-model="editForm.OfflineSpaceStat.eBusiness"
                                    placeholder="请输入"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="仓库空间（正整数）"
                                prop="OfflineSpaceStat.warehouse"
                                :rules="[
                                    { required: true, message: '请输入整数', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.OfflineSpaceStat.warehouse = switchToInt(editForm.OfflineSpaceStat.warehouse, 'unsigned')"
                                    v-model="editForm.OfflineSpaceStat.warehouse"
                                    placeholder="请输入"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="物流点（正整数）"
                                prop="OfflineSpaceStat.logisticsSite"
                                :rules="[
                                    { required: true, message: '请输入整数', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.OfflineSpaceStat.logisticsSite = switchToInt(editForm.OfflineSpaceStat.logisticsSite, 'unsigned')"
                                    v-model="editForm.OfflineSpaceStat.logisticsSite"
                                    placeholder="请输入"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="设计师（正整数）"
                                prop="OfflineSpaceStat.designer"
                                :rules="[
                                    { required: true, message: '请输入整数', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.OfflineSpaceStat.designer = switchToInt(editForm.OfflineSpaceStat.designer, 'unsigned')"
                                    v-model="editForm.OfflineSpaceStat.designer"
                                    placeholder="请输入"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="生产空间（正整数）"
                                prop="OfflineSpaceStat.production"
                                :rules="[
                                    { required: true, message: '请输入整数', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.OfflineSpaceStat.production = switchToInt(editForm.OfflineSpaceStat.production, 'unsigned')"
                                    v-model="editForm.OfflineSpaceStat.production"
                                    placeholder="请输入"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="门店数量（正整数）"
                                prop="OfflineSpaceStat.shop"
                                :rules="[
                                    { required: true, message: '请输入整数', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.OfflineSpaceStat.shop = switchToInt(editForm.OfflineSpaceStat.shop, 'unsigned')"
                                    v-model="editForm.OfflineSpaceStat.shop"
                                    placeholder="请输入"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="服务商数量（正整数）"
                                prop="OfflineSpaceStat.serviceProvider"
                                :rules="[
                                    { required: true, message: '请输入整数', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.OfflineSpaceStat.serviceProvider = switchToInt(editForm.OfflineSpaceStat.serviceProvider, 'unsigned')"
                                    v-model="editForm.OfflineSpaceStat.serviceProvider"
                                    placeholder="请输入"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item class="c-form-item-inner" label="公共服务网点（正整数）"
                                prop="OfflineSpaceStat.publicService"
                                :rules="[
                                    { required: true, message: '请输入整数', trigger: 'blur' },
                                ]"
                            >
                                <el-input
                                    @blur="editForm.OfflineSpaceStat.publicService = switchToInt(editForm.OfflineSpaceStat.publicService, 'unsigned')"
                                    v-model="editForm.OfflineSpaceStat.publicService"
                                    placeholder="请输入"
                                    :disabled="uneditable"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item class="c-form-item" label="订单类别统计">
                    <el-popover class="c-popover" placement="left" trigger="hover">
                        <img src="../../assets/images/datav-head/017.png" >
                        <div class="example-img" slot="reference">
                            <img src="../../assets/images/datav-head/017.png">
                        </div>
                    </el-popover>
                    <p class="info">
                       比例随机生成
                    </p>
                    <div class="c-row-wrap" v-for="(item, index) in editForm.orderTypeStat" :key="item.key">
                        <el-row :gutter="20">
                            <el-col :span="1">
                                <span class="c-sort-num">{{index + 1}}</span> 
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'orderTypeStat.' + index + '.name'"
                                    :rules="[
                                        { required: true, message: '请输入订单类别', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.name" :disabled="uneditable">
                                        <template slot="prepend">订单类别</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'orderTypeStat.' + index + '.min'"
                                    :rules="[
                                        { required: true, message: '请输入整数最小值', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.min" :disabled="uneditable"
                                        @blur="item.min = switchToInt(item.min, 'unsigned');switchMaxAndMin(editForm.orderTypeStat, index)"
                                    >
                                        <template slot="prepend">最小值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item class="c-form-item-inner"
                                    :prop="'orderTypeStat.' + index + '.min'"
                                    :rules="[
                                        { required: true, message: '请输入整数最小值', trigger: 'blur' },
                                    ]"
                                >
                                    <el-input placeholder="请输入" v-model="item.max" :disabled="uneditable"
                                        @blur="item.max = switchToInt(item.max, 'unsigned');switchMaxAndMin(editForm.orderTypeStat, index)"
                                    >
                                        <template slot="prepend">最大值</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" v-if="!uneditable">
                                <i class="el-icon-remove c-remove" 
                                    :class="{'disabled': editForm.orderTypeStat.length === 1}" 
                                    :title="editForm.orderTypeStat.length > 1 ? '删除该行': '只有一行，不允许删除'"
                                    @click="removeLine('orderTypeStat', index)"
                                ></i>
                                <i class="el-icon-circle-plus c-add" title="添加一行"
                                    @click="addLine('orderTypeStat', index)"
                                ></i>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item> 
            </el-form>
            <div class="bottom-btns-wrap" v-if="!uneditable">
                <el-button class="btn-cancel" @click="cancelEdit">取消</el-button>
                <el-button class="btn-large" type="primary" @click="submitHandle">提交</el-button>
            </div>
        </div>
        
        
    </div>
</template>

<script>
import {ajaxDatav} from '../../common/request_datav.js'
export default {
    data() {
        return {
            uneditable: true,
            editForm: {
                // 线上订单总金额
                totalOrderAmount: {
                    radix: '',   // 固定基数
                    dayMin: '',  // 每日随机最小值
                    dayMax: ''   // 每日随机最大值
                },

                // 订单总数
                totalOrderNumber: {
                    radix: ''   // 固定基数
                },

                // 本月注册
                monthRegistrations: {
                    radix: ''   // 固定基数
                },

                // 平均月活跃用户
                monthActiveUsers: {
                    radix: ''
                },   

                // 注册技能人员数
                skilledPersons: {
                    radix: ''
                },     

                // 带动就业人数
                createJobs: {
                    radix: ''
                },          

                // 订单种类统计
                orderTypeCount: {
                    fabric: '',     // 面辅料
                    design: '',     // 设计
                    sampleRoom: '', // 版房
                    processing: '', // 加工
                    sales: '',      // 销售
                },
                
                // 各产业园区产值及数据
                outputValueCount: [
                    {
                        key: 1,
                        name: '', // 园区名称
                        radix: '' // 年度总金额
                    }
                ],
                
                // 用户数量
                userNumber: {
                    radix: ''
                },

                // 公司数量
                companyNumber: {
                    radix: ''
                },

                // 面料采购
                fabricPurchasing: {
                    radix1: '', // 基数1
                    radix2: ''  // 基数2
                },

                // 服装库存
                apparelStock: {
                    radix: ''
                },

                // 引导纳税
                guideTaxPayment: {
                    rate: '', // 比例
                    radix: '' // 附加数据
                },

                // 平台各省订单交易信息
                provinceOrder: [
                    {
                        key: 1,
                        name: '', // 省份
                        rate: '', // 比例
                        radix: '' // 附加数据
                    }
                ],

                // 服装库存（按季节）
                seasonApparelStock: [
                    {
                        key: 1,
                        name: '', // 季节名称
                        min: '',  // 配置最小值
                        max: '',  // 配置最大值
                    }
                ],

                // 面料库存
                fabricStock: [
                    {
                        key: 1,
                        name: '', // 面辅料名称
                        min: '',  // 配置最小值
                        max: '',  // 配置最大值
                    }
                ],

                // 综合体线下空间统计数据
                OfflineSpaceStat: {
                    brand: '',          // 品牌孵化空间
                    fabric: '',         // 面料空间
                    eBusiness: '',      // 电商数量 -> 销售空间
                    warehouse: '',      // 仓库数量 -> 仓库空间
                    logisticsSite: '',   // 物流点
                    designer: '',        // 设计师
                    production: '',      // 生产空间
                    shop: '',            // 门店数量
                    serviceProvider: '', // 服务商数量
                    publicService: '',   // 公共服务网点
                },

                // 订单类别统计
                orderTypeStat: [
                    {
                        key: 1,
                        name: '', // 订单类别名称
                        min: '',  // 配置最小值
                        max: '',  // 配置最大值
                    }
                ],
            }
        }
    },
    created() {
        this.getData();
    },
    methods: {
        // 编辑操作
        editHandle() {
            this.uneditable = false
        },
        // 取消编辑
        cancelEdit() {
            this.$confirm('确认取消编辑吗?', '提示', {
                confirmButtonText: '取消编辑',
                cancelButtonText: '继续编辑',
                type: 'warning'
            }).then(() => {
                this.uneditable = true
                this.$refs['editForm'].clearValidate()
                this.getData();
            })
        },
        // 跳转外部链接
        linkToDataV() {
            window.open('https://datav.aliyuncs.com/share/c53490954456e2634851ef46253ee7ba')
        },
        // 立即生效
        takeEffectAtOnce() {
            this.$confirm('数据配置默认第二天零点生效，若需立即生效，可使用本功能。本功能将立即刷新数据到大屏，有可能造成当日数据前后不一致。请谨慎使用。', '提示', {
                confirmButtonText: '立即生效',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                console.log('立即生效')
                ajaxDatav.post('/data-statistics/refreshByNumber', {
                    number: 1
                }).then(res => {
                    if (res.code == 200) {
                        this.$message.success('提交成功，配置的数据会立即生效到大屏！');
                    } else {
                        this.$message.error(res.msg)
                    }
                }).catch(e => {
                    console.error(e)
                })
            }).catch(err=> {
                console.log(err)
            })
        },
        // 回到顶部
        toPageTop() {
            document.querySelector('#mainBox').scrollTop = 0;
        },
        // 删除一行
        removeLine(key, index) {
            let length = this.editForm[key].length
            if (length <= 1) return
            this.editForm[key].splice(index, 1)
        },
        // 添加一行
        addLine(key, index) {
            let d = Date.now()
            let item
            if (key == 'outputValueCount') {
                item = {
                    key: d,
                    name: '',
                    radix: ''
                }
            }
            if (key == 'provinceOrder') {
                item = {
                    key: d,
                    name: '',
                    rate: '',
                    radix: ''
                }
            }
            if (key == 'seasonApparelStock' || key == 'fabricStock' || key == 'orderTypeStat') {
                item = {
                    key: d,
                    name: '',
                    min: '',
                    max: ''
                }
            }
            this.editForm[key].splice(index+1, 0, item)
        },
        // 转化为整数
        switchToInt(value, type) {
            let v = parseInt(value)
            if (isNaN(v)) return ''
            return type === 'unsigned' ? Math.abs(v) : v
        },
        // 转化为浮点数
        switchToFloat(value, type) {
            let v = parseFloat(value)
            if (isNaN(v)) return ''
            return type === 'unsigned' ? Math.abs(v) : v
        },
        // 获取数据
        getData() {
            ajaxDatav.get('/data-setting/getByNumber', {
                number: 1
            }).then(res => {
                console.log(res)
                if (res.code == 200) {
                    if (res.data && res.data.content) {
                        try {
                            let content = JSON.parse(res.data.content);
                            this.editForm = {
                                ...this.editForm,
                                ...content
                            }
                        } catch (error) {
                            console.log(error)
                        }
                    }
                } else {
                    this.$message.error(res.msg)
                }
            }).catch(e => {
                console.error(e);
            })
        },
        // 提交表单
        submitHandle() {
            console.log('submit111');
            // console.log(this.editForm);
            // console.log(JSON.stringify(this.editForm));
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    const loading = this.$loading({
                        lock: true,
                        text: '正在提交数据...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    ajaxDatav.post('/data-setting/save', {
                        content: JSON.stringify(this.editForm),
                        number: 1
                    }).then(res => {
                        if (res.code == 200) {
                            this.$message.success('提交成功');
                            this.uneditable = true
                            this.getData();
                        } else {
                            this.$message.error(res.msg)
                        }
                    }).catch(e => {
                        console.error(e)
                    }).finally(() => {
                        loading.close();
                    })
                } else {
                    this.$message.error('校验不通过，请检查表单')
                }
            })
        },
        // 自定义校验规则
        validateTotalOrderAmount(rule, value, callback) {
            if (this.editForm.totalOrderAmount.dayMin === '' || this.editForm.totalOrderAmount.dayMax === '') {
                callback();
            } else if (
                this.editForm.totalOrderAmount.dayMin > this.editForm.totalOrderAmount.dayMax) {
                callback(new Error('最小值不能大于最大值!'));
            } else {
                this.$refs.editForm.clearValidate('totalOrderAmount.dayMin');
                this.$refs.editForm.clearValidate('totalOrderAmount.dayMax');
            }
        },
        // 自动切换对象中最大值和最小值
        switchObjMaxAndMin(obj, min='min', max='max') {
            if (obj[min] === '' || obj[max] === '') return
            if (obj[min] > obj[max]) {
                let middle = obj[min]
                obj[min] = obj[max]
                obj[max] = middle
            }
        },
        // 自动切换列表中最大值和最小值
        switchMaxAndMin(list, index, min='min', max='max') {
            if (list[index][min] === '' || list[index][max] === '') return
            if (list[index][min] > list[index][max]) {
                let middle = list[index][min]
                list[index][min] = list[index][max]
                list[index][max] = middle
            }
        }

    }
}
</script>

<style scoped lang="scss">
.page-wrapper {
    background: #fff;
    padding-bottom: 80px;
    min-height: 100px;
    .tit {
        margin: 0;
        padding: 24px;
        font-size: 20px;
        color: #111;
        font-weight: normal;
    }
    .top-btns {
        position: fixed;
        top: 40%;
        right: 32px;
        z-index: 100;
        .r-btn {
            margin-top: 6px;
        }
    } 
    .datav-form-wrapper {
        width: 900px;
        padding: 0 24px;
        .w {
            width: 400px;
        }
        .w2 {
            width: 200px;
        }
        .info {
            font-size: 13px;
            color: #888;
            line-height: 1.5;
        }
    }
    .c-row-wrap {
        padding: 8px 0;
    }
    .c-sort-num {
        margin-top: 12px;
        display: block;
        width: 20px;
        height: 20px;
        border: 1px solid #999;
        line-height: 20px;
        text-align: center;
        color: #999;
        font-size: 12px;
        border-radius: 50%;
    }
    .c-remove {
        margin-right: 4px;
        cursor: pointer;
        font-size: 16px;
        &.disabled {
            color: #ccc;
            cursor: no-drop;
        }
    }
    .c-add {
        font-size: 16px;
        cursor: pointer;
    }
    .bottom-btns-wrap {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        box-sizing: border-box;
        padding: 20px 0 20px 0px;
        text-align: center;
        z-index: 1;
        background: #fff;
        box-shadow: 0 -2px 10px #ccc;
        .btn-large {
            padding: 14px 120px;
        }
        .btn-cancel {
            padding-top: 14px;
            padding-bottom: 14px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/datav/head.vue